import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { config } from '../../shared/config';
import { LoggingService } from '../../shared/services/core/logging.service';
import { AuthService } from '../../user/services/auth.service';
import { SignalRWizardService } from './signalr-wizard.service';
import { SignalRBaseHub } from './signalr-basehub.service';

@Injectable({ providedIn: 'root' })
export class SignalRUnauthrosiedHub extends SignalRBaseHub {
  
  constructor(
    protected logService: LoggingService,
    protected signalRWizardService: SignalRWizardService,
    protected authService: AuthService,
    protected jwtHelper: JwtHelperService)
    { 
        super(logService,
            authService,
            jwtHelper);
    }

 /**
   * * Create a connection to the signlar hub (unauthorised)
   * @param orderId the order id of parameter
   */
  connectByOrderId(orderId: string) {
    this.createConnectionByOrderId(orderId);
    this.registerOnServerEvents();
    this.startConnection();
  }

   /**
   * Create SignalR connection using querystring
   */
   private createConnectionByOrderId(orderId: string) {
      this.hubConnection = new HubConnectionBuilder()
       .withUrl(config.baseApiUrl + '/huborder?orderId=' + orderId)
       .build();
  }

  /**
   * Register .on server events
   */
   protected registerOnServerEvents() {
    this.signalRWizardService.registerOnServerEvents(this.hubConnection);

    super.registerOnServerEvents();
  }
}
